import "src/assets/fontawesome/css/duotone.min.css"
import "src/assets/fontawesome/css/fontawesome.min.css"
import "src/assets/fontawesome/css/regular.min.css"
import "src/assets/fontawesome/css/solid.min.css"
import { boot } from "quasar/wrappers"
import { Icons } from "src/util/enums/fontAwesomeIcons"

export default boot(({ app }) => {
  // Patch the Font Awesome style of the icon set
  const fontAwesomeStyle = "fa-regular"

  const iconSet = app.config.globalProperties.$q.iconSet as unknown as {
    [key: string]: { [key: string]: string }
  }

  for (const key in iconSet) {
    if (key !== "name") {
      for (const subKey in iconSet[key]) {
        // Note: We slice 4 characters from the start, because that fits with the Font Awesome 5 way of denoting styles.
        iconSet[key][subKey] = `${fontAwesomeStyle} ${iconSet[key][subKey].slice(4)}`
      }
      // Overwriting default icons
      iconSet["field"]["clear"] = Icons.CLOSE
      iconSet["arrow"]["dropdown"] = Icons.CHEVRON_DOWN
    }
  }
})
